// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-signature-js": () => import("/Users/gauthier/Sites/b2a-mails/src/templates/signature.js" /* webpackChunkName: "component---src-templates-signature-js" */),
  "component---src-pages-index-js": () => import("/Users/gauthier/Sites/b2a-mails/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

